/* A11 · İsimli tasma arayüzü (planlar/2026-10-14-a11-isimli-tasma.md). Kaynak: isimli tasma/shopify/assets/bnco-product.js
   (26 Eylül); yerleşim, isim, renk, açılış animasyonu ve sepet akışı aynen korunur. Değişenler: başlık, fiyat, açıklama ve
   breadcrumb sunucuda çizilir (sections/bunico-tasma.liquid); bu dosya yalnız galeri ve seçenek yuvalarını doldurur, fiyatı
   .bn-pdp__price-now içine yazar. Motor sürümlü adresle yüklenir (config.motor), önbellekte eski kopya kalmaz.
   Sepete eklenince temanın çekmecesi yenilenip açılır; çekmece yoksa sepet sayfasına gidilir.
   Açılış animasyonu yalnız üç tasmadır: etiket ve alt yazı yok, zemin beyaz (Cem, 14 Ekim). */
const configEl = document.querySelector('bnco-personalizer [data-bnco-config]');
const motorUrl = configEl ? JSON.parse(configEl.textContent).motor : null;
const {
  PALETTE, FIGURES, PREVIEW_WIDTH_CM, COLLAR_SIZES, NECK_RANGES_CM, collarLayout, normalizeName, reconcileTokens,
  spriteName, tokenLabel, layoutTokens, summarize, resolveDesign, assertStock, addDesignToCart,
} = await import(motorUrl || new URL('bunico-tasma-motor.js', import.meta.url).href);

const spriteCache = new Map();
// Yalnız tanıtım: bu isimler müşterinin tasarımına, fiyatına veya sepetine yazılmaz.
const INTRO_DESIGNS = [
  {color:'sari',names:['LUNA','🐾ROBIN🐾','✿MAKI✿'],offset:0},
  {color:'lila',names:['LUNA','LULU♥','PATATES'],offset:1},
  {color:'sari',names:['MILO','ZEYTIN','SHAKIRA'],offset:2},
  {color:'lila',names:['MAX♥','BAMBI','♥OSCAR'],offset:0},
  {color:'sari',names:['LULU','DARWIN','MANTI★'],offset:1},
  {color:'lila',names:['LULU','✿MAKI✿','🐾ROBIN🐾'],offset:2},
  {color:'sari',names:['LUNA','♥OSCAR','BAMBI★'],offset:3},
  {color:'lila',names:['MILO','MANTI★','SHAKIRA'],offset:0},
];
// Açılış animasyonu (Cem, 14 Ekim): yazı alanlarına yakın görünüm. Yazı alanı = harflerin dizildiği bölüm (etiketin 1 cm
// solundan ilk ayar deliğine; motor nameStartCm…firstHoleCm). Üç tasma aynı cm ölçeğinde, yazı alanlarının ortası sahnenin
// ortasında hizalı; sahne genişliği Large yazı alanı + iki yanda INTRO_MARGIN_CM. Tasmanın kalanı sahne kenarından taşar.
const INTRO_MARGIN_CM = 1.5;
// Kısa isimler logonun sağında durduğu için yazılar sahnede sağa kayık görünüyordu (Cem): hizalama noktası 2 cm sağa,
// görüntü 2 cm sola.
const INTRO_SHIFT_CM = 2;
const COLLARS = {
  lila:{label:'Lila',swatch:'#b79bce'},
  sari:{label:'Sarı',swatch:'#f2cb2b'},
};
const SIZE_NAMES = {S:'Small',M:'Medium',L:'Large'};
const LOW_STOCK = 3;
function imageLoaded(url) {
  return new Promise((resolve,reject) => {
    const img = new Image(); img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img); img.onerror = () => reject(new Error('Ürün görseli yüklenemedi.'));
    img.src = url;
  });
}
function sprite(url, hex) {
  const key = url + hex;
  if (!spriteCache.has(key)) spriteCache.set(key, imageLoaded(url).then(img => {
    const canvas = document.createElement('canvas');
    canvas.width = img.naturalWidth; canvas.height = img.naturalHeight;
    const ctx = canvas.getContext('2d', { willReadFrequently:true }); ctx.drawImage(img,0,0);
    const pixels = ctx.getImageData(0,0,canvas.width,canvas.height);
    let left=canvas.width,top=canvas.height,right=-1,bottom=-1;
    for(let y=0;y<canvas.height;y++)for(let x=0;x<canvas.width;x++){
      if(pixels.data[(y*canvas.width+x)*4+3]>20){left=Math.min(left,x);top=Math.min(top,y);right=Math.max(right,x);bottom=Math.max(bottom,y);}
    }
    const rgb = [1,3,5].map(i => parseInt(hex.slice(i,i+2),16));
    for (let i=0; i<pixels.data.length; i+=4) {
      if (!pixels.data[i+3]) continue;
      if(hex.toLowerCase()==='#5286b6') continue;
      const light = (pixels.data[i]+pixels.data[i+1]+pixels.data[i+2])/398;
      const highlight = Math.max(0,light-1)*100;
      rgb.forEach((v,j) => { pixels.data[i+j] = Math.min(255,v*light+highlight); });
    }
    ctx.putImageData(pixels,0,0);
    // Görünen harfi ölç; görselin saydam kenar boşluğu hesaba girmez.
    if(right<left)throw new Error('Empty letter image');
    const trimmed=document.createElement('canvas');trimmed.width=right-left+1;trimmed.height=bottom-top+1;
    trimmed.getContext('2d').drawImage(canvas,left,top,trimmed.width,trimmed.height,0,0,trimmed.width,trimmed.height);
    const profile=[];
    for(let y=top;y<=bottom;y++){
      let first=right+1,last=-1;
      for(let x=left;x<=right;x++)if(pixels.data[(y*canvas.width+x)*4+3]>20){first=Math.min(first,x);last=x;}
      profile.push(last<first?null:[(first-left)/trimmed.height,(last-left+1)/trimmed.height]);
    }
    return {url:trimmed.toDataURL('image/png'),aspect:trimmed.width/trimmed.height,profile};
  }).catch(error => { spriteCache.delete(key); throw error; }));
  return spriteCache.get(key);
}
const esc = value => String(value ?? '').replace(/[&<>"']/g,c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const cm = value => String(value).replace('.',',');

class BunicoPersonalizer extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    const configEl = this.querySelector('[data-bnco-config]');
    if (!configEl) return;
    this.config = JSON.parse(configEl.textContent);
    this.commerceEnabled=this.config.commerce?.enabled===true;
    this.fitReady=false;this.saving=false;this.needsCartReview=false;
    this.ready = true;
    this.tokens = []; this.nextId = 0; this.selectedId = null; this.defaultColor = null;
    this.collar = 'lila'; this.size = 'M'; this.qty = 1; this.caret = 0; this.view = 'preview';
    this.revision = 0; this.cleanups = []; this.nodes = new Map();
    this.mount(); this.listen(); this.update(); this.prepareFigures(); this.prepareThumbs();
    this.startIntro();
  }
  disconnectedCallback() {
    this.stopIntro();
    this.revision++; this.cleanups?.forEach(cleanup => cleanup());
    this.ready = false;
  }
  q(selector) { return this.querySelector(selector); }
  all(selector) { return [...this.querySelectorAll(selector)]; }
  // Handoff fiyat biçimi "2.000 ₺" (snippets/bunico-price.liquid ile aynı); kuruş varsa ",50".
  money(cents) {
    if((this.config.currency||'TRY')!=='TRY')return new Intl.NumberFormat('tr-TR',{style:'currency',currency:this.config.currency}).format(cents/100);
    const lira=Math.floor(cents/100),kurus=Math.round(cents%100);
    return `${lira.toLocaleString('tr-TR')}${kurus?','+String(kurus).padStart(2,'0'):''} ₺`;
  }
  asset(name) { return this.config.letters?.[name] || new URL(`bunico-tasma-harf-${name}.webp`,import.meta.url).href; }
  photo(collar = this.collar) { return this.config.photos[collar]; }
  sizesPhoto(color) { return this.config.sizesPhotos?.[color] || {src:this.photo(color),srcset:'',alt:''}; }
  geometry() { return collarLayout(this.size,this.collar).letters; }
  neck(size) { const [a,b]=NECK_RANGES_CM[size]; return `${a}–${b} cm`; }
  collarVariant(size,color) { return this.config.commerce?.catalog?.find(v=>v.sku===`BNC-COLLAR-${size}-${color.toUpperCase()}`); }
  sizePrice(size) {
    const variant=this.commerceEnabled&&this.collarVariant(size,this.collar);
    return variant ? variant.price : (this.config.prices?.[size] ?? {S:100000,M:120000,L:140000}[size]);
  }
  renderCollar(plane,color=this.collar,size=this.size) {
    const layout=collarLayout(size,color), crop=plane.querySelector('.bnco-photo-crop');
    // Tasmanın tamamı çerçeveye sığar; harfler onunla birlikte ölçeklenir.
    const frameScale=1/layout.length;
    plane.style.width=`${frameScale*100}%`;
    plane.style.left=`${(1-frameScale)*50}%`;
    if(crop.children.length!==layout.strips.length || !crop.querySelector('.bnco-photo-strip')){
      crop.replaceChildren();
      for(let i=0;i<layout.strips.length;i++){
        const strip=document.createElement('span');strip.className='bnco-photo-strip';
        const img=document.createElement('img');img.className='bnco-base';img.alt='';strip.append(img);crop.append(strip);
      }
    }
    crop.setAttribute('role','img');
    crop.setAttribute('aria-label',`${COLLARS[color].label} Bunico ${size} beden tasma, ${layout.lengthCm} × ${cm(layout.widthCm)} cm`);
    layout.strips.forEach((part,i)=>{
      const strip=crop.children[i],img=strip.firstChild;
      strip.style.left=`${part.left*100}%`;strip.style.width=`${part.width*100}%`;
      img.style.width=`${layout.source.width/(part.to-part.from)*100}%`;
      img.style.height=`${layout.source.height*layout.scale*300}%`;
      img.style.left=`${-part.from/(part.to-part.from)*100}%`;
      img.style.top=`${50-layout.source.centerY*layout.scale*300}%`;
      if(img.getAttribute('src')!==this.photo(color))img.src=this.photo(color);
    });
    plane.style.setProperty('--bn-center',`${layout.letters.center*100}%`);
  }
  mount() {
    const max=this.config.maxLetters||7;
    const sizes=['lila','sari'].map(c=>this.sizesPhoto(c));
    // Galeri sırası: canlı önizleme, ürün videoları (Cem, 17 Ekim; ürün medyasından), toplu beden fotoğrafları, harf panosu.
    const videos=(this.config.videos||[]).filter(v=>v.sources?.length);
    const items=[
      {thumb:'onizleme',label:'Kişiselleştirilmiş tasma önizlemesi'},
      ...videos.map((v,i)=>({thumb:`video-${i}`,label:v.alt,video:v})),
      {thumb:'boy-lila',label:sizes[0].alt||'S, M ve L boy lila Bunico tasmalar birlikte',photo:sizes[0]},
      {thumb:'boy-sari',label:sizes[1].alt||'S, M ve L boy sarı Bunico tasmalar birlikte',photo:sizes[1]},
      {thumb:'pano',label:'Harfler ve figürler'},
    ];
    // Dikey video için 720p yeterli; yoksa en yüksek kaynak.
    const source=v=>v.sources.find(s=>s.height>=700)||v.sources.at(-1);
    this.q('[data-bnco-slot="gallery"]').innerHTML = `
      <div class="bnco-gallery">
        <div class="bnco-thumbs" role="group" aria-label="Ürün görselleri">${items.map((it,i)=>`<button type="button" class="bnco-thumb${it.video?' bnco-thumb--video':''}" data-gallery-index="${i}" aria-label="${esc(it.label)}" aria-pressed="${i===0}"><span class="bnco-thumb-art" data-thumb="${it.thumb}">${it.video?`<img src="${esc(it.video.poster)}" alt="" loading="lazy">`:''}</span></button>`).join('')}</div>
        <div class="bnco-gallery-main">
          <div class="bnco-gallery-track" aria-label="Ürün görselleri" tabindex="0">
            <div class="bnco-stage bnco-gallery-item" data-zoom="false" role="group" aria-label="Kişiselleştirilmiş tasma önizlemesi">
              <div class="bnco-stage-top"><button class="bnco-zoom" type="button" aria-label="Yakınlaştır" aria-pressed="false"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="7" stroke="currentColor" stroke-width="2"/><path d="m15 15 6 6M6 10h8m-4-4v8" stroke="currentColor" stroke-width="2"/></svg></button></div>
              <div class="bnco-art"><div class="bnco-plane"><div class="bnco-photo-crop"></div><div class="bnco-letter-layer" aria-hidden="true"></div></div></div>
              <div class="bnco-opening" hidden>
                <div class="bnco-opening-art" aria-hidden="true">${['S','M','L'].map(size=>`<div class="bnco-opening-row" data-intro-size="${size}"><div class="bnco-plane"><div class="bnco-photo-crop"></div><div class="bnco-letter-layer"></div></div></div>`).join('')}</div>
                <button type="button" class="bnco-opening-toggle" aria-label="Örnek animasyonunu duraklat">Ⅱ</button>
              </div>
              <p class="bnco-photo-error" role="alert" hidden>Görsel yüklenemedi. Sayfayı yenileyerek tekrar deneyebilirsin.</p>
            </div>
            ${items.filter(it=>it.video).map(it=>`<figure class="bnco-gallery-item bnco-gallery-item--video"><video class="bnco-gallery-video" playsinline muted loop controls preload="none" poster="${esc(it.video.poster)}" aria-label="${esc(it.label)}"><source src="${esc(source(it.video).url)}" type="${esc(source(it.video).type||'video/mp4')}"></video></figure>`).join('')}
            ${items.filter(it=>it.photo).map(it=>`<figure class="bnco-gallery-item"><img class="bnco-gallery-photo" src="${esc(it.photo.src)}" ${it.photo.srcset?`srcset="${esc(it.photo.srcset)}" sizes="(min-width: 900px) 50vw, 100vw"`:''} alt="${esc(it.label)}" loading="lazy"></figure>`).join('')}
            <div class="bnco-gallery-item" role="group" aria-label="Harfler ve figürler"><div class="bnco-board"></div></div>
          </div>
          <div class="bnco-gallery-navigation"><button type="button" data-gallery-step="-1" aria-label="Önceki ürün görseli" disabled>‹</button><span class="bnco-gallery-count" aria-live="polite">1 / ${items.length}</span><div class="bnco-gallery-dots">${items.map((_,i)=>`<button type="button" data-gallery-index="${i}" aria-label="${i+1}. ürün görseli" aria-pressed="${i===0}"></button>`).join('')}</div><button type="button" data-gallery-step="1" aria-label="Sonraki ürün görseli">›</button></div>
        </div>
      </div>`;
    this.q('[data-bnco-slot="options"]').innerHTML = `
      <div class="bnco-option">
        <div class="bnco-head"><span class="bnco-head-name">Renk</span><span class="bnco-choice-label"></span></div>
        <div class="bnco-dots" role="group" aria-label="Tasma rengi">${Object.entries(COLLARS).map(([id,c])=>`<button type="button" class="bnco-dot" data-collar="${id}" aria-label="${c.label}" aria-pressed="${id===this.collar}" style="--bn-dot:${c.swatch}"></button>`).join('')}</div>
      </div>
      <div class="bnco-option">
        <div class="bnco-head"><span class="bnco-head-name">Beden</span></div>
        <div class="bnco-sizes" role="group" aria-label="Beden">${['S','M','L'].map(s=>`<button type="button" class="bnco-size" data-size="${s}" aria-pressed="${s===this.size}"><span class="bnco-size-name">${SIZE_NAMES[s]}</span><span class="bnco-size-price"></span><span class="bnco-size-measure"></span><span class="bnco-size-stock"></span></button>`).join('')}</div>
      </div>
      <div class="bnco-option">
        <div class="bnco-head"><label class="bnco-head-name">İsim</label><span class="bnco-counter">0 / ${max}</span></div>
        <div class="bnco-input-wrap"><input class="bnco-name" aria-label="Köpeğinin ismi" placeholder="Örn. LUNA" autocomplete="off" autocapitalize="characters" spellcheck="false"><button type="button" class="bnco-clear" aria-label="İsmi temizle" hidden>×</button></div>
        <p class="bnco-help" aria-live="polite"></p>
        <div class="bnco-figures"><span>Bir figür ekle</span>${FIGURES.map(f => `<button type="button" class="bnco-figure" data-figure="${f.name}" aria-label="${f.label} ekle"><img alt="" src="${esc(this.asset(f.name))}"></button>`).join('')}</div>
        <div class="bnco-token-editor" hidden><p class="bnco-editor-title">Bir harfe dokun, rengini seç.</p><div class="bnco-chips" role="group" aria-label="Harf renklerini düzenle"></div>
          <div class="bnco-palette"><span class="bnco-palette-label"></span>${PALETTE.map((p,i) => `<button type="button" class="bnco-swatch" data-color="${i}" style="--swatch:${p.hex}" aria-label="${p.label} harf rengi" aria-pressed="false"></button>`).join('')}<button type="button" class="bnco-apply-all">Tümüne uygula</button></div>
        </div>
      </div>
      <div class="bnco-order"><div class="bnco-quantity"><button type="button" data-qty="-1" aria-label="Adedi azalt">−</button><output aria-label="Adet">1</output><button type="button" data-qty="1" aria-label="Adedi artır">+</button></div><button type="button" class="bnco-submit bnco-review"><span>Tasarımını incele</span></button></div>`;
    this.insertAdjacentHTML('beforeend',`
      <div class="bnco-mini" hidden aria-hidden="true"><span class="bnco-mini-label">CANLI ÖNİZLEME</span><div class="bnco-mini-scene"></div></div>
      <dialog class="bnco-dialog" aria-labelledby="${this.id}-dialog-title"><h2 id="${this.id}-dialog-title">Tasarımın hazır.</h2><p class="bnco-summary"></p><p class="bnco-summary-colors"></p><p class="bnco-summary-price"></p><p class="bnco-dialog-note">${this.commerceEnabled?'Tasma ve seçtiğin parçalar birlikte sepete eklenecek.':'Bu sayfa tasarım önizlemesidir. Henüz sepete veya ödeme adımına bağlanmadı.'}</p><p class="bnco-cart-status" role="status"></p><a class="bnco-cart-link" hidden>Sepeti kontrol et</a><button type="button" class="bnco-submit bnco-add-cart" ${this.commerceEnabled?'':'hidden'}>Sepete ekle</button><button type="button" class="bnco-secondary bnco-dialog-close">Tasarıma dön</button></dialog>
      <p class="bnco-sr-status visually-hidden" role="status"></p>`);
    const table=this.q('[data-bnco-size-table]');
    if(table){
      // Beden tablosu (Cem, 14 Ekim): köpeğin boyun çevresi ve tasma genişliği (motor COLLAR_SIZES: S/M 2 cm, L 2,5 cm).
      table.innerHTML=`<table><thead><tr><th>Beden</th><th>Boyun çevresi</th><th>Tasma genişliği</th></tr></thead><tbody>${['S','M','L'].map(s=>`<tr><td>${SIZE_NAMES[s]}</td><td>${this.neck(s)}</td><td>${cm(COLLAR_SIZES[s].widthCm)} cm</td></tr>`).join('')}</tbody></table>`;
    }
    this.priceEl = this.q('.bn-pdp__price-now');
    this.input = this.q('.bnco-name');
    this.input.id = `bnco-name-${crypto.randomUUID()}`;
    this.q('.bnco-option label.bnco-head-name').htmlFor = this.input.id;
    this.renderCollar(this.q('.bnco-art .bnco-plane'));
  }
  listen() {
    const on = (node,event,handler,capture=false) => { node.addEventListener(event,handler,capture); this.cleanups.push(()=>node.removeEventListener(event,handler,capture)); };
    on(this,'click',event=>this.click(event));
    on(this.input,'focus',()=>this.stopIntro());
    on(document,'visibilitychange',()=>this.scheduleIntro());
    const motion=matchMedia('(prefers-reduced-motion: reduce)');
    on(motion,'change',()=>{if(motion.matches&&this.introActive){this.introPlaying=false;this.scheduleIntro();this.syncIntroToggle();}});
    on(this.input,'input',event=>{
      if (event.isComposing) return;
      this.readInput();
    });
    on(this.input,'compositionend',()=>this.readInput());
    ['select','click','keyup','blur'].forEach(event=>on(this.input,event,()=>{ this.caret=this.input.selectionStart; this.selectionEnd=this.input.selectionEnd; }));
    on(this.q('.bnco-dialog'),'click',event=>{ if(event.target===this.q('.bnco-dialog')) this.q('.bnco-dialog').close(); });
    this.mainVisible=true;
    const observer=new IntersectionObserver(entries=>{this.mainVisible=entries[0].isIntersecting;this.updateMiniVisibility();this.scheduleIntro();});
    observer.observe(this.q('.bnco-stage'));this.cleanups.push(()=>observer.disconnect());
    on(this.q('.bnco-dialog'),'close',()=>this.updateMiniVisibility());
    on(this.q('.bnco-gallery-track'),'scroll',()=>this.updateGalleryNavigation());
    on(this.q('.bnco-gallery-track'),'keydown',event=>{
      if(event.key==='ArrowLeft'||event.key==='ArrowRight'){
        event.preventDefault();this.goToGallery((this.galleryIndex||0)+(event.key==='ArrowRight'?1:-1));
      }
    });
    // Görsel olayları kabarmaz; yakalama aşamasında dinlenir.
    on(this.q('.bnco-art'),'error',()=>{ this.q('.bnco-photo-error').hidden=false; },true);
    on(this.q('.bnco-art'),'load',()=>{ this.q('.bnco-photo-error').hidden=true; },true);
  }
  startIntro() {
    this.introActive=true;this.introPlaying=!matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.introIndex=0;this.introRevision=(this.introRevision||0)+1;
    this.syncIntroToggle();this.drawIntro();
  }
  syncIntroToggle() {
    const button=this.q('.bnco-opening-toggle');
    button.textContent=this.introPlaying?'Ⅱ':'▶';
    button.setAttribute('aria-label',this.introPlaying?'Örnek animasyonunu duraklat':'Örnek animasyonunu oynat');
  }
  scheduleIntro() {
    clearTimeout(this.introTimer);
    if(!this.introActive||!this.introPlaying||!this.introReady||document.hidden||!this.mainVisible)return;
    this.introTimer=setTimeout(()=>{this.introIndex=(this.introIndex+1)%INTRO_DESIGNS.length;this.drawIntro();},1400);
  }
  async drawIntro() {
    const revision=++this.introRevision;
    this.introReady=false;clearTimeout(this.introTimer);
    const design=INTRO_DESIGNS[this.introIndex];
    try {
      // Üç satır birlikte hazırlanır: üç isim aynı karede değişir.
      const rows=await Promise.all(['S','M','L'].map(async(size,row)=>{
        const tokens=Array.from(design.names[row]).map((char,i)=>({id:`intro-${size}-${i}`,char,color:(i+row+design.offset)%PALETTE.length}));
        const sprites=await Promise.all(tokens.map(token=>this.tokenSprite(token)));
        const geometry=collarLayout(size,design.color);
        const letters=layoutTokens(tokens,sprites.map(sp=>sp.aspect),{...geometry.letters,profiles:sprites.map(sp=>sp.profile)});
        return {size,sprites,geometry,letters};
      }));
      if(!this.introActive||revision!==this.introRevision||!this.isConnected)return;
      const large=collarLayout('L',design.color),viewCm=large.firstHoleCm-large.nameStartCm+2*INTRO_MARGIN_CM;
      rows.forEach(({size,sprites,geometry,letters})=>{
        const row=this.q(`[data-intro-size="${size}"]`),plane=row.querySelector('.bnco-plane');
        this.renderCollar(plane,design.color,size);
        // Ortak ölçek; yazı alanının ortası sahnenin ortasında.
        const centerCm=geometry.left*PREVIEW_WIDTH_CM+(geometry.nameStartCm+geometry.firstHoleCm)/2+INTRO_SHIFT_CM;
        plane.style.width=`${PREVIEW_WIDTH_CM/viewCm*100}%`;
        plane.style.left=`${(viewCm/2-centerCm)/viewCm*100}%`;
        const layer=plane.querySelector('.bnco-letter-layer');layer.replaceChildren();
        letters.forEach((item,i)=>{
          const node=document.createElement('span');node.className='bnco-letter bnco-opening-letter';
          node.style.cssText=`left:${item.x*100}%;top:${item.y*100}%;width:${item.width*100}%;height:${item.height*300}%;--intro-delay:${i*45}ms`;
          const img=document.createElement('img');img.src=sprites[i].url;img.alt='';node.append(img);layer.append(node);
        });
        row.dataset.introName=design.names[['S','M','L'].indexOf(size)];
      });
      this.q('.bnco-opening').hidden=false;this.q('.bnco-stage').dataset.intro='true';
      this.introReady=true;this.scheduleIntro();
    } catch {if(revision===this.introRevision)this.stopIntro();}
  }
  stopIntro() {
    this.introActive=false;this.introPlaying=false;this.introReady=false;
    this.introRevision=(this.introRevision||0)+1;clearTimeout(this.introTimer);
    const opening=this.q('.bnco-opening');if(opening)opening.hidden=true;
    const stage=this.q('.bnco-stage');if(stage)delete stage.dataset.intro;
  }
  goToGallery(index) {
    const track=this.q('.bnco-gallery-track'),items=this.all('.bnco-gallery-item');
    index=Math.max(0,Math.min(items.length-1,index));
    track.scrollTo({left:items[index].offsetLeft-items[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
  updateGalleryNavigation() {
    const track=this.q('.bnco-gallery-track'),items=this.all('.bnco-gallery-item');
    this.galleryIndex=items.reduce((best,item,i)=>Math.abs(item.offsetLeft-items[0].offsetLeft-track.scrollLeft)<Math.abs(items[best].offsetLeft-items[0].offsetLeft-track.scrollLeft)?i:best,0);
    this.q('.bnco-gallery-count').textContent=`${this.galleryIndex+1} / ${items.length}`;
    this.q('[data-gallery-step="-1"]').disabled=this.galleryIndex===0;
    this.q('[data-gallery-step="1"]').disabled=this.galleryIndex===items.length-1;
    this.all('[data-gallery-index]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.galleryIndex)===this.galleryIndex)));
  }
  readInput() {
    this.stopIntro();
    const raw=this.input.value, caret=this.input.selectionStart;
    const cleaned=normalizeName(raw), max=this.config.maxLetters || 7;
    const chars=cleaned.slice(0,max);
    this.tokens=reconcileTokens(this.tokens,chars,()=>`t${++this.nextId}`,this.defaultColor);
    this.input.value=chars.join('');
    this.caret=normalizeName(raw.slice(0,caret)).slice(0,max).join('').length;
    this.input.setSelectionRange(this.caret,this.caret); this.selectionEnd=this.caret;
    this.view='preview';
    this.goToGallery(0);
    this.warning=cleaned.length>max ? `En fazla ${max} harf veya figür ekleyebilirsin.` : (raw!==chars.join('') && raw.toUpperCase()!==chars.join('') ? 'İsim, mevcut A–Z harflerine uygun hale getirildi.' : '');
    this.update();
  }
  click(event) {
    const button=event.target.closest('button'); if(!button || !this.contains(button)) return;
    if(this.saving)return;
    if(button.classList.contains('bnco-opening-toggle')){
      this.introPlaying=!this.introPlaying;this.syncIntroToggle();this.scheduleIntro();return;
    }
    if(button.dataset.galleryStep) {this.goToGallery((this.galleryIndex||0)+Number(button.dataset.galleryStep));return;}
    if(button.dataset.galleryIndex!==undefined) {this.goToGallery(Number(button.dataset.galleryIndex));return;}
    if(button.closest('.bnco-dialog')){
      if(button.classList.contains('bnco-add-cart')) this.addToCart();
      else if(button.classList.contains('bnco-dialog-close')) this.q('.bnco-dialog').close();
      return;
    }
    // Açıklama akordiyonları ve başka düğmeler tanıtımı kapatmaz; yalnız tasarım seçenekleri kapatır.
    if(!button.closest('[data-bnco-slot]'))return;
    this.stopIntro();
    if(button.dataset.collar) { this.collar=button.dataset.collar; this.view='preview';this.goToGallery(0); }
    else if(button.dataset.size) {
      this.size=button.dataset.size;this.view='preview';
      this.q('.bnco-stage').dataset.zoom='false';
      this.q('.bnco-zoom').setAttribute('aria-pressed','false');
      this.q('.bnco-zoom').setAttribute('aria-label','Yakınlaştır');this.goToGallery(0);
    }
    else if(button.dataset.figure) {
      const figure=FIGURES.find(f=>f.name===button.dataset.figure);
      const value=this.input.value;
      const start=Math.min(this.caret??value.length,value.length), end=Math.min(this.selectionEnd??start,value.length);
      this.input.value=value.slice(0,start)+figure.char+value.slice(end);
      this.input.focus({preventScroll:true});this.input.setSelectionRange(start+figure.char.length,start+figure.char.length);
      this.readInput();return;
    } else if(button.dataset.token) this.selectedId=button.dataset.token;
    else if(button.dataset.color!==undefined) {
      const token=this.tokens.find(t=>t.id===this.selectedId);
      if(token) token.color=Number(button.dataset.color);
    } else if(button.classList.contains('bnco-apply-all')) {
      const token=this.tokens.find(t=>t.id===this.selectedId);
      if(token) { this.defaultColor=token.color;this.tokens=this.tokens.map(t=>({...t,color:token.color})); }
    } else if(button.dataset.qty) this.qty=Math.max(1,Math.min(99,this.qty+Number(button.dataset.qty)));
    else if(button.classList.contains('bnco-clear')) {
      this.input.value='';this.readInput();this.input.focus({preventScroll:true});return;
    } else if(button.classList.contains('bnco-zoom')) {
      const stage=this.q('.bnco-stage'), zoom=stage.dataset.zoom!=='true';
      stage.dataset.zoom=String(zoom);button.setAttribute('aria-pressed',String(zoom));button.setAttribute('aria-label',zoom?'Uzaklaştır':'Yakınlaştır');return;
    } else if(button.classList.contains('bnco-review')) {
      if(!this.fitReady||this.stockError)return;
      if(!this.tokens.length) {this.input.focus();return;}
      this.q('.bnco-summary').textContent=`${this.tokens.map(t=>t.char).join('')} · ${COLLARS[this.collar].label} · ${SIZE_NAMES[this.size]} · ${this.qty} adet`;
      this.q('.bnco-summary-colors').textContent=summarize(this.tokens);
      this.q('.bnco-summary-price').textContent=`Toplam: ${this.money(this.total*this.qty)}`;
      this.q('.bnco-cart-status').textContent='';
      this.q('.bnco-dialog').showModal();this.updateMiniVisibility();return;
    }
    else return;
    this.update();
  }
  update() {
    let base=this.sizePrice(this.size);
    const letterPrice=this.config.letterPrice??7500;
    this.total=base+this.tokens.length*letterPrice;
    this.stockError='';this.design=null;
    if(this.commerceEnabled){
      try{
        this.design=resolveDesign(this.config.commerce.catalog,{size:this.size,color:this.collar,tokens:this.tokens,quantity:this.qty,maxLetters:this.config.maxLetters||7});
        base=this.design.collar.price;this.total=this.design.unitTotal;
        assertStock(this.design);
      }catch(error){this.stockError=error.message;}
    }
    const breakdown=this.q('[data-bnco-breakdown]');
    if(this.priceEl)this.priceEl.innerHTML=`<span class="visually-hidden">Fiyat:</span>${esc(this.money(this.total))}`;
    if(breakdown)breakdown.textContent=this.tokens.length?`${SIZE_NAMES[this.size]} tasma ${this.money(base)} + ${this.tokens.length} harf/figür × ${this.money(letterPrice)}`:`${SIZE_NAMES[this.size]} tasma · her harf ve figür ${this.money(letterPrice)}`;
    if(this.commerceEnabled&&!this.design){if(this.priceEl)this.priceEl.textContent='—';if(breakdown)breakdown.textContent='Seçilen ürün satışa hazır değil.';}
    this.q('.bnco-choice-label').textContent=COLLARS[this.collar].label;
    this.q('.bnco-counter').textContent=`${this.tokens.length} / ${this.config.maxLetters||7}`;
    this.q('.bnco-help').textContent=this.stockError||this.warning||`A–Z harfleri ve figürler · her biri ${this.money(letterPrice)}`;
    this.q('.bnco-help').dataset.warning=String(Boolean(this.stockError||this.warning));
    this.q('.bnco-clear').hidden=!this.tokens.length;
    this.q('.bnco-token-editor').hidden=!this.tokens.length;
    this.q('.bnco-quantity output').textContent=this.qty;
    this.q('[data-qty="-1"]').disabled=this.qty===1;
    this.q('[data-qty="1"]').disabled=this.qty===99;
    this.q('.bnco-review span').textContent=this.tokens.length?`Tasarımını incele · ${this.money(this.total*this.qty)}`:'Tasarımını incele';
    this.all('[data-collar]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.collar===this.collar)));
    this.all('[data-size]').forEach(b=>{
      const size=b.dataset.size;
      b.setAttribute('aria-pressed',String(size===this.size));
      b.querySelector('.bnco-size-price').textContent=this.money(this.sizePrice(size));
      b.querySelector('.bnco-size-measure').textContent=`Boyun ${this.neck(size)}`;
      const stock=b.querySelector('.bnco-size-stock'),variant=this.commerceEnabled&&this.collarVariant(size,this.collar);
      if(variant&&variant.inventoryManagement){
        const n=variant.inventoryQuantity??0,sold=!variant.available||n<=0;
        stock.textContent=sold?'Tükendi':n<=LOW_STOCK?`Son ${n} adet`:'Stokta';
        stock.dataset.state=sold?'sold':n<=LOW_STOCK?'low':'ok';b.classList.toggle('is-sold',sold);
      }else{stock.textContent='';delete stock.dataset.state;b.classList.remove('is-sold');}
    });
    this.all('[data-figure]').forEach(b=>{b.disabled=this.tokens.length>=(this.config.maxLetters||7);});
    this.renderCollar(this.q('.bnco-art .bnco-plane'));
    this.q('.bnco-plane').style.setProperty('--bn-center',`${this.geometry().center*100}%`);
    if(!this.tokens.some(t=>t.id===this.selectedId)) this.selectedId=this.tokens.at(-1)?.id||null;
    this.updateChips();this.drawLetters();this.updateThumbs();
    this.updateMiniVisibility();
  }
  updateThumbs(){
    const first=this.q('[data-thumb="onizleme"]');
    if(first&&first.dataset.collar!==this.collar){first.dataset.collar=this.collar;first.innerHTML=`<img src="${esc(this.photo())}" alt="">`;}
  }
  // Telefonda üstteki mini önizleme, yukarı kaydırınca geri gelen yapışkan header'ın altında kalmasın diye üstte header
  // yüksekliği kadar beyaz boşluk bırakır (Cem, 15 Ekim); header görünmese de boşluk kalır, arada sayfa görünmez.
  updateMiniVisibility(){
    const mini=this.q('.bnco-mini');
    mini.hidden=this.mainVisible||!this.tokens.length||this.view!=='preview'||this.q('.bnco-dialog').open;
    if(!mini.hidden){
      const h=Math.max(...['.bn-sticky-header .header__top','.bn-header .header__top'].map(s=>document.querySelector(s)?.getBoundingClientRect().height||0));
      mini.style.setProperty('--bn-mini-ust',`${Math.round(h||64)}px`);
    }
  }
  syncMini(){
    const source=this.q('.bnco-art .bnco-plane'), target=this.q('.bnco-mini-scene');
    if(!target.firstChild)target.append(source.cloneNode(true));
    const copy=target.firstChild;
    copy.style.cssText=source.style.cssText;
    this.renderCollar(copy);
    const layer=copy.querySelector('.bnco-letter-layer'), originals=[...source.querySelectorAll('.bnco-letter')];
    const ids=new Set(originals.map(n=>n.dataset.id));
    [...layer.children].forEach(n=>{if(!ids.has(n.dataset.id))n.remove();});
    for(const original of originals){
      let mirror=[...layer.children].find(n=>n.dataset.id===original.dataset.id);
      if(!mirror){mirror=original.cloneNode(true);layer.append(mirror);}
      mirror.hidden=original.hidden;mirror.style.cssText=original.style.cssText;mirror.firstChild.src=original.firstChild.src;
    }
  }
  async tokenSprite(token) {return sprite(this.asset(spriteName(token.char)),PALETTE[token.color].hex);}
  updateChips() {
    const chips=this.q('.bnco-chips'), ids=new Set(this.tokens.map(t=>t.id));
    [...chips.children].forEach(el=>{if(!ids.has(el.dataset.token))el.remove();});
    for(const [index,token] of this.tokens.entries()) {
      let chip=[...chips.children].find(el=>el.dataset.token===token.id);
      if(!chip) {chip=document.createElement('button');chip.type='button';chip.className='bnco-chip';chip.dataset.token=token.id;chip.append(document.createElement('img'));}
      const label=`${index+1}. ${tokenLabel(token.char)}, ${PALETTE[token.color].label}`;
      chip.setAttribute('aria-label',label);chip.setAttribute('aria-pressed',String(token.id===this.selectedId));
      const key=`${token.char}-${token.color}`;
      if(chip.dataset.sprite!==key) {
        chip.dataset.sprite=key;
        this.tokenSprite(token).then(sp=>{if(chip.dataset.sprite===key){chip.firstChild.src=sp.url;chip.firstChild.alt=tokenLabel(token.char);}}).catch(()=>{chip.firstChild.alt=tokenLabel(token.char);});
      }
      if(chips.children[index]!==chip)chips.insertBefore(chip,chips.children[index]||null);
    }
    const selected=this.tokens.find(t=>t.id===this.selectedId);
    this.q('.bnco-palette-label').textContent=selected?`${tokenLabel(selected.char)} için:`:'';
    this.all('[data-color]').forEach(b=>b.setAttribute('aria-pressed',String(selected?.color===Number(b.dataset.color))));
  }
  async drawLetters() {
    const version=++this.revision;
    this.fitReady=false;this.syncPurchaseButtons();
    const tokens=this.tokens.map(t=>({...t}));
    try {
      const sprites=await Promise.all(tokens.map(t=>this.tokenSprite(t)));
      if(version!==this.revision||!this.isConnected)return;
      const geometry=this.geometry();
      const layout=layoutTokens(tokens,sprites.map(sp=>sp.aspect),{...geometry,profiles:sprites.map(sp=>sp.profile)});
      const width=layout.length?layout.at(-1).x+layout.at(-1).width/2-(layout[0].x-layout[0].width/2):0;
      const overflows=width>(geometry.availableWidth??.32);
      this.fitReady=!overflows;this.syncPurchaseButtons();
      if(overflows){
        const n=v=>v.toLocaleString('tr-TR',{maximumFractionDigits:1});
        this.q('.bnco-help').textContent=`Bu isim yaklaşık ${n(width*PREVIEW_WIDTH_CM)} cm yer kaplıyor; ${SIZE_NAMES[this.size]} bedende logo üzeri dahil ${n(geometry.availableWidth*PREVIEW_WIDTH_CM)} cm yer var. Daha kısa bir isim veya daha büyük beden deneyebilirsin.`;
        this.q('.bnco-help').dataset.warning='true';
      }
      const layer=this.q('.bnco-letter-layer');
      const wanted=new Set(tokens.map(t=>t.id));
      for(const [id,node] of this.nodes)if(!wanted.has(id)){node.remove();this.nodes.delete(id);}
      layout.forEach((item,i)=>{
        let node=this.nodes.get(item.id);
        if(!node){node=document.createElement('span');node.className='bnco-letter is-new';node.dataset.id=item.id;node.append(document.createElement('img'));layer.append(node);this.nodes.set(item.id,node);node.firstChild.addEventListener('animationend',()=>node.classList.remove('is-new'),{once:true});}
        node.hidden=overflows;
        node.style.left=`${item.x*100}%`;node.style.top=`${item.y*100}%`;
        node.style.width=`${item.width*100}%`;node.style.height=`${item.height*300}%`;
        node.firstChild.src=sprites[i].url;node.firstChild.alt='';
      });
      this.q('.bnco-sr-status').textContent=`Önizleme: ${tokens.map(t=>tokenLabel(t.char)).join(', ')||'Boş tasma'}`;
      this.syncMini();
    }catch{
      if(version===this.revision)this.q('.bnco-help').textContent='Bazı harf görselleri yüklenemedi. Sayfayı yenileyip tekrar deneyebilirsin.';
    }
  }
  syncPurchaseButtons(){
    this.q('.bnco-review').disabled=this.saving||!this.fitReady||Boolean(this.stockError);
    this.q('.bnco-add-cart').disabled=this.saving||!this.fitReady||Boolean(this.stockError)||this.needsCartReview||!this.tokens.length;
  }
  // Temanın çekmecesini yeniler ve açar (component-cart.js renderHelperCart + section-main-product.js'teki gibi show()).
  // Çekmece yoksa (sepet ayarı sayfa, ya da /cart) sepet sayfasına gidilir.
  async openCart(){
    const drawer=document.getElementById('site-cart-sidebar');
    if(!drawer||typeof drawer.show!=='function'||typeof window.renderHelperCart!=='function'||!document.getElementById('AjaxCartForm')){
      window.location.assign(this.config.commerce.cartUrl);return;
    }
    const html=await (await fetch(`?section_id=${window.KT_FILE_PREFIX||''}helper-cart`)).text();
    window.renderHelperCart(html);
    drawer.show();
    const oneriler=document.getElementById('cart-recommendations');
    if(oneriler&&typeof oneriler.generateRecommendations==='function')oneriler.generateRecommendations();
    window.KROWN?.functions?.eventDispatcher?.('krown:cart:add',{});
  }
  async addToCart(){
    if(!this.commerceEnabled||this.saving||!this.fitReady||this.stockError||this.needsCartReview||!this.tokens.length)return;
    this.saving=true;this.syncPurchaseButtons();this.q('.bn-tasma__info').inert=true;
    this.q('.bnco-add-cart').textContent='Sepete ekleniyor…';
    this.q('.bnco-cart-status').textContent='';
    let added=false;
    try{
      const design=resolveDesign(this.config.commerce.catalog,{size:this.size,color:this.collar,tokens:this.tokens.map(t=>({...t})),quantity:this.qty,maxLetters:this.config.maxLetters||7});
      await addDesignToCart(design,{cartUrl:this.config.commerce.cartUrl,group:crypto.randomUUID()});
      added=true;
      this.q('.bnco-cart-status').textContent='Tasarımın tüm parçaları sepete eklendi.';
      this.q('.bnco-dialog').close();
      await this.openCart();
    }catch(error){
      if(added){window.location.assign(this.config.commerce.cartUrl);return;}
      this.needsCartReview=Boolean(error.needsCartReview);
      this.q('.bnco-cart-status').textContent=error.message;
      if(this.needsCartReview){const link=this.q('.bnco-cart-link');link.href=this.config.commerce.cartUrl;link.hidden=false;}
    }finally{
      this.saving=false;this.q('.bn-tasma__info').inert=false;
      this.q('.bnco-add-cart').textContent='Sepete ekle';this.syncPurchaseButtons();
    }
  }
  async prepareFigures() {
    for(const f of FIGURES)try{const sp=await sprite(this.asset(f.name),'#9a9d90');if(this.isConnected)this.q(`[data-figure="${f.name}"] img`).src=sp.url;}catch{}
  }
  // Harf panosu galerinin dördüncü görseli; görünür olunca (veya küçük görseline basılınca) yüklenir.
  prepareThumbs() {
    const board=this.q('.bnco-board'),thumb=this.q('[data-thumb="pano"]');
    sprite(this.asset('A'),PALETTE[2].hex).then(sp=>{if(thumb)thumb.innerHTML=`<img src="${sp.url}" alt="">`;}).catch(()=>{});
    ['lila','sari'].forEach(c=>{const el=this.q(`[data-thumb="boy-${c}"]`),p=this.sizesPhoto(c);if(el&&p.src)el.innerHTML=`<img src="${esc(p.src)}" alt="" loading="lazy">`;});
    const fill=()=>{
      if(board.dataset.filled)return;board.dataset.filled='true';
      const names=[...'ABCDEFGHIJKLMNOPQRSTUVWXYZ',...FIGURES.map(f=>f.char)];
      names.forEach((char,i)=>{
        const img=document.createElement('img');img.alt=tokenLabel(char);board.append(img);
        sprite(this.asset(spriteName(char)),PALETTE[i%4].hex).then(sp=>{img.src=sp.url;}).catch(()=>{img.alt=char;});
      });
    };
    const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){fill();observer.disconnect();}},{root:this.q('.bnco-gallery-track'),rootMargin:'0px 50% 0px 50%'});
    observer.observe(board.parentElement);this.cleanups.push(()=>observer.disconnect());
    this.prepareVideos();
  }
  // Ürün videosu galeride görünür olunca sessiz oynar, çıkınca durur; hareketi azaltma tercihinde kendiliğinden oynamaz.
  prepareVideos() {
    const videos=this.all('.bnco-gallery-video');if(!videos.length)return;
    const reduce=matchMedia('(prefers-reduced-motion: reduce)');
    const observer=new IntersectionObserver(entries=>{
      for(const e of entries){
        const v=e.target;
        if(e.isIntersecting&&e.intersectionRatio>=.6&&!reduce.matches&&!document.hidden){v.play().catch(()=>{});}
        else if(!v.paused)v.pause();
      }
    },{threshold:[0,.6]});
    videos.forEach(v=>observer.observe(v));this.cleanups.push(()=>observer.disconnect());
  }
}
if(!customElements.get('bnco-personalizer'))customElements.define('bnco-personalizer',BunicoPersonalizer);
